// composables/useOrderHeader.ts
export function useOrderHeader() {
  return useState<{
    id: number,
    batchNumber: string
    customerOrder: string
    salesOrder: string
    operatorName: string
    productionDate: string
    status: string
    notes: string
  } | null>('order-header', () => null)
}